import apiFetch from '../apiFetch'

export default function (values, token) {
  return apiFetch({endPoint: `Instalacion/getFiltrarInstalacion`, method: 'POST', body: values, token: token})
}
